import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateFormulaService } from '../../../../../core/services/proprietary/date-formula.service';
import { DateFormulaType } from '../../../../../core/services/proprietary/date-formula.types';

const noop = () => { };

@Component({
    standalone: false,
    selector: 'ep-date-formula-input',
    template: `
    <div class="'unity-form-group date" style="margin:0px; padding:0px">
      <label *ngIf="!noLabel"><ng-content></ng-content></label>
      <div #dpGroup class="unity-form-row" style="position:relative">
        <input
          class="unity-date"
          #inputElement
          [(ngModel)]="currentInput"
          (ngModelChange)="inputChanged($event)"
          [class]="!disabled ? 'form-control' : ''"
          [disabled]="disabled"
          (focus)="onFocus()"
          (blur)="onBlur()"
        />
        <aurora-icon
          icon="calculator"
          #toggleButton
          (click)="disabled ? null : openDateFormulaDialog(format)"
          tabindex="-1"
          [style.cursor]="disabled ? 'not-allowed' : ''"
        ></aurora-icon>
      </div>
    </div>
  `,
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: DateFormulaInputComponent, multi: true }]
})
export class DateFormulaInputComponent implements ControlValueAccessor {
    @ViewChild('epInput') epInput;

    @Input() noLabel: boolean = false;
    @Input() format: DateFormulaType = DateFormulaType.Date;

    @Input()
    disabled: boolean = false;

    @Output()
    blur = new EventEmitter();

    @Output()
    focus = new EventEmitter();

    public currentInput: string;

    //The internal data model
    private innerValue: any = '';

    //Placeholders for the callbacks which are later provided
    //by the Control Value Accessor
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    constructor(private dateFormula: DateFormulaService, private cdRef: ChangeDetectorRef) { }

    inputChanged(inputVal: string) {
        let newVal = '';
        if (inputVal) {
            newVal = inputVal;
        }
        this.value = newVal;
    }

    ////get accessor
    get value(): any {
        return this.innerValue;
    }

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
    }

    onBlur() {
        if (this.innerValue) {
            if (!this.dateFormula.validateFormula(this.format, this.innerValue)) {
                this.value = '';
                this.currentInput = '';
            }
        }

        this.blur.emit();
        this.onTouchedCallback();
    }

    onFocus() {
        this.focus.emit();
    }

    //From ControlValueAccessor interface
    writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
            this.currentInput = value;
            this.cdRef.detectChanges();
        }
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    //From ControlValueAccessor interface -  Allows Angular to disable the input.
    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    openDateFormulaDialog(formulaType: DateFormulaType) {
        this.dateFormula.openDialog(formulaType, this.dialogResult.bind(this));
    }

    dialogResult(result: any) {
        if (result) {
            this.value = result;
            this.currentInput = result;
            this.onBlur();
        }
    }
}
